// Player apartments (§8): publish your home layout so others can visit; browse and visit theirs.
import { flag } from "@degen/shared/flags";
import type { GameState } from "@degen/sim/state";
import type { Placement } from "@degen/sim/houses/houses";
import { api } from "./api";
import { session } from "./session";

let timer: ReturnType<typeof setTimeout> | null = null;

/** Debounced: publish a few seconds after you stop decorating. */
export function publishApartment(state: GameState) {
  if (!flag("apartments") || !session.value) return;
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    const home = state.houses.owned.find((h) => h.id === state.houses.homeId);
    if (home) void api("PUT", "/apartment", { houseId: home.id, layout: home.layout }).catch(() => {});
  }, 3000);
}

export const listApartments = () => api<{ handle: string; house_id: string }[]>("GET", "/apartments", undefined, { auth: false });
export const getApartment = (handle: string) => api<{ handle: string; houseId: string; layout: Placement[]; pfpSeed: number }>("GET", `/apartment/${encodeURIComponent(handle)}`, undefined, { auth: false });
